import React, { Component, Children } from "react";
import "./Modal.css";
import { Icon } from "semantic-ui-react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
// import { ReactComponent as CrossIcon } from "../../../assets/svg/cross-icon.svg";
import { ReactComponent as CrossIcon } from "../../assets/svg/cross-icon.svg";

class Modal extends Component {
    handleDimmerClick(e) {
        if (e.currentTarget === e.target) this.props.onClose && this.props.onClose();
    }

    getModalStyles() {
        let styles = {};
        if (this.props.width) styles.width = this.props.width;
        if (this.props.height) styles.height = this.props.height;
        if (this.props.overflowY) styles.overflowY = this.props.overflowY;
        return styles;
    }

    render() {
        return (
            <CSSTransition {...this.props} show="" timeout={200} classNames="slidedown" unmountOnExit={true} in={this.props.show}>
                <div className="skiptranslate">
                    <div className="csmodal-dimmer" onClick={(e) => this.handleDimmerClick(e)}>
                        <div className="csmodal-backdrop">
                            <div className={`csmodal ${this.props.className || ""}`} style={this.getModalStyles()}>
                                {React.Children.map(this.props.children, (child) => React.cloneElement(child, { onClose: this.props.onClose }))}
                            </div>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        );
        // return null
    }
}

class Header extends Component {
    render() {
        return (
            <div className={`csmodal-header skiptranslate ${this.props.className || ""}`}>
                <div className="header">{this.props.children}</div>
                <CrossIcon className="csmodal-close-icon" name="close" style={{ width: "20px", height: "20px" }} onClick={() => this.props.onClose()} />
            </div>
        );
    }
}

class Content extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className={`csmodal-content ${this.props.className || ""} ${this.props.noSkipGTranslate ? "" : "skiptranslate"}`}>{this.props.children}</div>
        );
    }
}

class Actions extends Component {
    render() {
        return <div className={`csmodal-actions skiptranslate ${this.props.className || ""}`}>{this.props.children}</div>;
    }
}

export class ActionButton extends Component {
    render() {
        return (
            <span onClick={() => this.props.onClick()} className={`csaction-button skiptranslate ${this.props.className}`}>
                {this.props.children}
            </span>
        );
    }
}

export class ConfirmModal extends Modal {
    render() {
        return (
            <CSSTransition {...this.props} timeout={200} classNames="slidedown" unmountOnExit={true} in={this.props.show}>
                <div>
                    <div className="csmodal-dimmer skiptranslate" onClick={(e) => this.handleDimmerClick(e)}>
                        <div className="csmodal-backdrop">
                            <div className={`csmodal csmodal-confirm ${this.props.className || ""}`} style={this.getModalStyles()}>
                                {React.Children.map(this.props.children, (child) => React.cloneElement(child, { onClose: this.props.onClose }))}
                            </div>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        );
    }
}

Modal.Header = Header;
Modal.Content = Content;
Modal.Actions = Actions;
Modal.ActionButton = ActionButton;
export default Modal;
